import $ from "jquery";
import "slick-carousel";
export default class HomeSlide {
  constructor() {
    $(".home-slider").slick({
      enabled: true,
      autoplay: true,
      slickArrows: false,
      dots: true,
      rows: 0,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
    });
  }
}
